(() => {
  const selector = '[data-weighted-empty-cart]';

  function initializeEmptyCart(root) {
    if (root.dataset.weightedEmptyCartReady === 'true') return;

    const trigger = root.querySelector('[data-weighted-empty-cart-trigger]');
    if (!trigger) return;

    root.dataset.weightedEmptyCartReady = 'true';

    const showFullCart = () => root.classList.add('is-full');
    const showEmptyCart = () => {
      if (root.dataset.weightedEmptyCartNavigating !== 'true') {
        root.classList.remove('is-full', 'is-touch-transition');
      }
    };

    const triggers = [trigger, root.querySelector('.weighted-empty-cart__stage')].filter(Boolean);
    triggers.forEach((trigger) => {
    trigger.addEventListener('pointerenter', showFullCart);
    trigger.addEventListener('pointerleave', showEmptyCart);
    trigger.addEventListener('focus', showFullCart);
    trigger.addEventListener('blur', showEmptyCart);

    trigger.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' || event.pointerType === 'pen') {
        root.classList.add('is-full', 'is-touch-transition');
      }
    });

    trigger.addEventListener('pointercancel', showEmptyCart);

    trigger.addEventListener('click', (event) => {
      const modifiedClick = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
      const touchLayout = window.matchMedia('(hover: none), (pointer: coarse)').matches;

      if (!touchLayout || modifiedClick || event.detail === 0) return;

      event.preventDefault();
      if (root.dataset.weightedEmptyCartNavigating === 'true') return;

      root.dataset.weightedEmptyCartNavigating = 'true';
      root.classList.add('is-full', 'is-touch-transition');

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.setTimeout(() => {
        window.location.assign(trigger.href);
      }, reduceMotion ? 0 : 420);
    });
    });
  }

  function initializeAllEmptyCarts(scope = document) {
    scope.querySelectorAll(selector).forEach(initializeEmptyCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAllEmptyCarts());
  } else {
    initializeAllEmptyCarts();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllEmptyCarts(event.target);
  });
})();
